import { computed, Injectable, signal } from '@angular/core';
import { Opco } from '../base/entities/opco';
import { CachingHttpClient } from './caching-http-client';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OpcoService {
  private readonly writableOpcos = signal<Opco[]>([]);

  public readonly opcos = this.writableOpcos.asReadonly();
  public readonly isInitialized = computed(() => {
    return this.opcos().length > 0;
  });

  constructor(private readonly cachingHttpClient: CachingHttpClient) {}

  /**
   * Fetches all {@link Opco}s, {@link Depot}s and raster locations for which this {@link User} is authorized.
   * If the application is offline, the most recent response is returned instead.
   */
  initialize() {
    return this.cachingHttpClient.get<Opco[]>('api/GetOpcosAndDepots').pipe(
      tap((opcos) => this.writableOpcos.set(opcos)),
      catchError((error) => {
        this.writableOpcos.set([]);
        throw error;
      })
    );
  }

  depots(opcoCode: string | null) {
    return computed(() => {
      return this.opcos()
        .filter((opco) => opco.code === opcoCode) // Also works if opcoCode is null.
        .flatMap((opco) => opco.depots);
    });
  }

  depot(depotCode: string | null) {
    return computed(() => {
      return this.opcos()
        .flatMap((opco) => opco.depots)
        .find((depot) => depot.id === depotCode);
    });
  }

  clear() {
    this.writableOpcos.set([]);
    this.cachingHttpClient.clear();
  }
}
